import React from 'react'
import CommonSharedFileList from '../../../common/pages/secure/SharedFileList'
import Config from '../../../Config'
import PageHeader from '../../components/PageHeader'

class SharedFileList extends CommonSharedFileList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyUserApiUrl.systemSettings
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
  renderPageNavi () {
    return (
      <PageHeader title='事務局からの共有ファィル一覧' sub='こちらから事務局からの共有ファィルを確認できます。' history={this.props.history} />
    )
  }
}

export default SharedFileList



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/SharedFileList.js